<!-- Navbar -->
<nav class="main-header navbar navbar-expand navbar-white navbar-light">
    <!-- Left navbar links -->
    <ul class="navbar-nav">
      <li class="nav-item">
        <a class="nav-link" data-widget="pushmenu" href="#" role="button"><i class="fas fa-bars"></i></a>
      </li>
    </ul>

    <!-- Right navbar links -->
    <ul class="navbar-nav ml-auto">
      <!-- Notifications Dropdown Menu -->
     <li class="nav-item dropdown">
        <a class="nav-link" data-toggle="dropdown" href="#">
          <i class="far fa-bell"></i>
          <span class="badge badge-danger navbar-badge" *ngIf="unreadCount > 0">
            {{ unreadCount }}
          </span>
        </a>

        <div class="dropdown-menu dropdown-menu-lg dropdown-menu-right notification-dropdown">
          <span class="dropdown-item dropdown-header">
            {{ unreadCount }} Notifications
          </span>
          <div class="dropdown-divider"></div>

          <ng-container *ngFor="let n of notifications; trackBy: trackById; let last = last">
           <div
                class="dropdown-item notification-item"
                [class.unread]="!n.read"
                [class.clickable]="!isLong(n.message)"
                (click)="onItemClick(n, $event)"
              >
                <div class="d-flex align-items-start">
                  <i class="fas fa-envelope mr-2 mt-1 text-danger"></i>
                  <div class="notification-text">
                    <div class="notification-title" *ngIf="n.title">{{ n.title }}</div>

                    <div class="notification-message" [class.clamped]="isLong(n.message)">
                      {{ n.message }}
                    </div>

                    <a href="#" class="read-more" *ngIf="isLong(n.message)" (click)="openDetails(n, $event)">
                      Read more
                    </a>

                    <span class="text-muted text-sm d-block mt-1">{{ n.created_at | timeAgo }}</span>
                  </div>
                </div>
              </div>
            <div class="dropdown-divider" *ngIf="!last"></div>
          </ng-container>
        </div>
      </li>

      <li class="nav-item dropdown user-menu">
        <a href="#" class="nav-link dropdown-toggle" data-toggle="dropdown">
          <img src="/assets/adminlte/img/no_image.jpg" class="user-image img-circle elevation-2" alt="User Image">
          <span class="d-none d-md-inline">{{ user_full_name }}</span>
        </a>
        <ul class="dropdown-menu dropdown-menu-lg dropdown-menu-right">
          <!-- User image -->
          <li class="user-header bg-primary">
            <img src="/assets/adminlte/img/no_image.jpg" class="img-circle elevation-2" alt="User Image">

            <p>
              {{ user_full_name }}
              <small>Member since April 2023</small>
            </p>
          </li>
          <!-- Menu Body -->
          <li class="user-body">
            <div class="row">
              <div class="col-12 text-center">
                <button *ngIf="needsNotificationPermission" (click)="enableNotifications()" class="btn btn-info">
                  Enable notifications
                </button>
              </div>
            </div>
            <!-- /.row -->
          </li>
          <!-- Menu Footer-->
          <li class="user-footer">
            <a href="#" class="btn btn-default btn-flat">Change Password</a>
            <button (click)="logout()" type="button" class="btn btn-danger btn-flat float-right">Sign out</button>
          </li>
        </ul>
      </li>
      <li class="nav-item">
        <a class="nav-link" data-widget="fullscreen" href="#" role="button">
          <i class="fas fa-expand-arrows-alt"></i>
        </a>
      </li>
    </ul>
  </nav>
  <!-- /.navbar -->
